import React, { Fragment, useState } from 'react';
import { compressAccurately } from 'image-conversion';


const AddExpense = ({ expenses, setExpenses }) => {

    const [cost, setCost] = useState("");
    const [description, setDescription] = useState("");
    const [image, setImage] = useState(null);

    const onSubmitForm = async (e) => {

        if (cost === 0) {
            return
        }
        var reader = new FileReader();
        var data = "";


        reader.onload = async function () {
            data = reader.result.replace("data: ", "").replace(/&.+,/, "");

            await setExpenses(expenses.concat([{ cost: Math.round(cost * 100), description: description, image: data }]))
        }
        compressAccurately(image, 200).then(res => {
            if (res != null) {
                reader.readAsDataURL(res)
            }
        }).catch(fail => {
            setExpenses(expenses.concat([{ cost: Math.round(cost * 100), description: description }]))
        })

        cancel() //bad function name. Just clears the shit

    }

    const cancel = () => {
        setCost("")
        setDescription("")
        document.getElementById("file_upload").value = '';
        setImage(null)
    }

    return (
        <Fragment>
            <button type="button" className="btn btn-info mt-2" data-toggle="modal" data-target={`#addExpense`}>
                Add an Expense
            </button>

            <div className="modal fade" id={`addExpense`}>
                <div className="modal-dialog">
                    <div className="modal-content">



                        <div className="modal-header">
                            <h4 className="modal-title">Expense Information</h4>
                            <button type="button" className="close" data-dismiss="modal" onClick={cancel}>&times;</button>
                        </div>

                        <div className="modal-body">
                            <p>Cost ($)</p>
                            <input placeholder="Cost ($)" type="number" className="form-control" value={cost} onChange={e => setCost(e.target.value)} />
                            <p className="mt-2">Description</p>
                            <input placeholder="Description" type="text" className="form-control" value={description} onChange={e => setDescription(e.target.value)} />
                            <p className="mt-2">Image Evidence</p>
                            <input id="file_upload" type="file" accept=".png, .jpg, .jpeg" onChange={e => setImage(e.target.files[0])}></input>

                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-success" onClick={onSubmitForm} data-dismiss="modal">Add</button>
                            <button type="button" className="btn btn-warning" onClick={cancel} data-dismiss="modal">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default AddExpense;